import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-taquets',
  templateUrl: './taquets.component.html',
  styleUrls: ['./taquets.component.scss']
})
export class TaquetsComponent implements OnInit {

  @Input() title?: string;
  @Input() description?: string;
  @Input() items: Array<{ title: string, button?: string, content?: string }>;

  selected: number;

  constructor() {
    this.selected = 0;
  }

  ngOnInit() {
  }

  public onClickTaquet(event: Event, index: number) {
    this.selected = index;
  }

}
